import { combineReducers } from "redux";
import { actions } from "../actions/action-list";
import initialState from "./intitalState";
import Auth from "./authReducer";
import Collection from "./collectionReducer";
import Cities from "./citiesReducer";
import Operators from "./operatorsReducer";
import CardCollection from "./cardCollectionReducer";
import BreakDown from "./dayWiseBreakDownReducer";
import DateDue from "./dateDueBreakDownReducer";
import { loadingBarReducer } from "../../shared/widgets/bar-loader/src";
import Contracts from "./contractReducer";
import DateFilter from "./dateFilterReducer";
import Notification from "./notificationReducer";
import OperatorView from "./operatorViewReducer";
import Settlement from "./settlementReducer";
import Overview from "./overviewReducer";
import OperationType from "./operationTypeReducer";
import Report from "./distanceReportReducer";
import ReportsType from "./reportsTypeReducer";
import ExportBtnPages from "./exportBtnReducer";
import GenerateReports from "./reportsModuleReducer";
import Expenses from "./expenseReducer";
import AdminConfig from "./adminConfigReducer";
import PassRevenue from "./passRevenueReducer";
import OperatorSettlementConfig from "./operatorSettlementConfigReducer";
import OndcReportUpload from "./ondcReportUploadReducer";
import operatorConfigEdit from "./operatorConfigEditReducer";

const appReducer = combineReducers({
  Auth,
  Collection,
  Contracts,
  Cities,
  Operators,
  CardCollection,
  BreakDown,
  DateDue,
  DateFilter,
  loadingBar: loadingBarReducer,
  Notification,
  Settlement,
  Overview,
  OperationType,
  Report,
  ReportsType,
  ExportBtnPages,
  OperatorView,
  GenerateReports,
  Expenses,
  AdminConfig,
  PassRevenue,
  OperatorSettlementConfig,
  OndcReportUpload,
  operatorConfigEdit,
});

export default function rootReducer(state, action) {
  let appState = state;
  if (action.type === actions.LOG_OUT) {
    appState = initialState;
  }
  return appReducer(appState, action);
}
